import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import './profile.css'

// COMPONENTS
import { Column } from '@components/templates/column'

// ROUTES
import { DefaultRoute } from './default'
import { EmailRoute } from './email'
import { PhoneRoute } from './phone'
import { SMSSettingsRoute } from './sms-settings'

// TYPES
import type { RouteObject } from 'react-router-dom'


const Component: FC<{}> = () => (
    <Column.Content className="account-profile-screen">
        <Outlet />
    </Column.Content>
)

const ProfileRoute: RouteObject = {
    path: "profile",
    Component,
    children: [
        DefaultRoute,
        EmailRoute,
        PhoneRoute,
        SMSSettingsRoute
    ]
}

export { ProfileRoute }
